import React, { useMemo } from "react";
import { Flipped } from "react-flip-toolkit";
import * as TabStyles from "./Tab.style";

var Tab = _ref => {
  var { className, disabled, index, label, selectedTab, onTabClick = () => {} } = _ref;

  var handleClick = () => !disabled && onTabClick(index);

  var isSelected = useMemo(() => index !== undefined && selectedTab === index, [
    selectedTab,
    index
  ]);
  var stylesArray = [className, isSelected && "selected", disabled && "disabled"]
    .filter(Boolean)
    .join(" ");
  return /*#__PURE__*/ React.createElement(
    TabStyles.TabLi,
    {
      className: stylesArray,
      role: "menuitem",
      onClick: handleClick
    },
    /*#__PURE__*/ React.createElement(TabStyles.StyledLabel, null, label),
    isSelected &&
      /*#__PURE__*/ React.createElement(
        Flipped,
        {
          flipId: "tab-header-border"
        },
        /*#__PURE__*/ React.createElement(TabStyles.TabBorder, null)
      )
  );
};

export { TabStyles };
export default Tab;
